import {
  CloseButton,
  Copyright,
  Divider,
  FooterRow,
  HeaderRow,
  MainRow,
  NavCol,
  NavRow,
  Order,
  Presentation,
  RowTitle,
  SafariFixContainer,
  Scroll,
  SocialNavRow,
  Spacer,
  StyledSpan,
} from './styles';
import { LinkedInLink } from '@/components/ui/icons/SocialIcons';

import { Close } from '@styled-icons/material/Close';
import CtaArrow from '@/components/ui/buttons/CtaArrow';
import NavLink from '@/components/Nav/NavLink';
import React from 'react';
import { useRouter } from 'next/router';

interface MenuProps {
  onClose?: () => void;
  companyList?: unknown[];
  solutionsList?: unknown[];
  workList?: unknown[];
  isTransparent?: boolean;
  social?: unknown;
  footer?: unknown;
}

const Menu: React.FC<MenuProps> = ({
  onClose,
  companyList = [],
  solutionsList = [],
  workList = [],
  isTransparent,
  social,
  footer,
}) => {
  const router = useRouter();

  return (
    <Presentation role="presentation">
      <HeaderRow middle="xs" end="xs" isTransparent={isTransparent}>
        <CtaArrow to="/contact">{`LET'S CHAT`}</CtaArrow>
        <CloseButton onClick={onClose}>
          <Close size={36} />
        </CloseButton>
      </HeaderRow>
      <Scroll>
        <SafariFixContainer>
          <MainRow around="lg" style={{ flex: 'auto' }}>
            <NavCol xs={12} sm md lg>
              <NavRow end="xs">
                <RowTitle>Company</RowTitle>
              </NavRow>
              {companyList.map(({ text, url }) => (
                <NavRow end="xs" key={text}>
                  <NavLink active={router.asPath === url.replace(/\/$/, '')} to={url} onClose={onClose}>
                    {text}
                  </NavLink>
                </NavRow>
              ))}
            </NavCol>
            <NavCol xs={12} sm md lg>
              <NavRow end="xs">
                <RowTitle>Solutions</RowTitle>
              </NavRow>
              {solutionsList.map(({ text, url }) => (
                <NavRow end="xs" key={text}>
                  <NavLink active={router.asPath === url.replace(/\/$/, '')} to={url} onClose={onClose}>
                    {text}
                  </NavLink>
                </NavRow>
              ))}
            </NavCol>
            <NavCol xs={12} sm={8} smOffset={4} md mdOffset={0} lg>
              <NavRow end="xs">
                <RowTitle>Work</RowTitle>
              </NavRow>
              {workList.map(({ text, url }) => (
                <NavRow end="xs" key={text}>
                  <NavLink active={router.asPath === url.replace(/\/$/, '')} to={url} onClose={onClose}>
                    {text}
                  </NavLink>
                </NavRow>
              ))}
            </NavCol>
          </MainRow>
        </SafariFixContainer>
        <FooterRow>
          <MainRow style={{ width: '100%' }}>
            <NavCol xs={10} xsOffset={2} sm={10} smOffset={2} md={10} mdOffset={2} lg={10} lgOffset={2}>
              <Divider />
            </NavCol>
            <Order>
              <NavCol xs={12} sm md lg>
                <NavRow end="xs">
                  <StyledSpan>211 W Wacker Dr Ste 120 #1090, Chicago, IL 60606</StyledSpan>
                </NavRow>
                {(
                  footer as {
                    leftColumn?: { links?: Array<{ text: string; url: string }> };
                  }
                )?.leftColumn?.links?.map(({ text, url }) => (
                  <NavRow end="xs" key={text}>
                    <NavLink
                      to={url}
                      style={{
                        minWidth: '200px' /* this is a fix for safari, somehow the phone was being clipped */,
                      }}
                    >
                      {text}
                    </NavLink>
                  </NavRow>
                ))}
              </NavCol>
              <NavCol xs={12} sm md mdOffset={4} lg lgOffset={4}>
                <NavRow end="xs">
                  <RowTitle>Follow Us</RowTitle>
                </NavRow>
                <SocialNavRow end="xs">
                  <LinkedInLink url={(social as { linkedIn: string }).linkedIn} />
                </SocialNavRow>
              </NavCol>
            </Order>
            <NavCol xs={12} sm={12} md={12} lg={12}>
              <Copyright>
                &copy; {new Date().getFullYear()} Foxbox, LLC - All Rights Reserved
                <Spacer />
                <NavLink to="/privacy">Privacy Policy</NavLink>
              </Copyright>
            </NavCol>
          </MainRow>
        </FooterRow>
      </Scroll>
    </Presentation>
  );
};

export default Menu;
